/**
 * Validation utility functions
 */

/**
 * Validates and normalizes a phone number to E.164 format
 * @param {string} phoneNumber - The phone number to validate
 * @returns {string|boolean} - The normalized phone number or false if invalid
 */
const namePattern = /^[a-zA-ZÀ-ÿ\s\-. '&]+$/;
const zipPattern = /^[a-zA-Z0-9\s-]+$/;
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateName = (value) => !value || namePattern.test(value);
export const validateCityState = (value) => !value || namePattern.test(value);
export const validateZip = (value) => !value || zipPattern.test(value);
export const validateEmail = (value) => !value || emailPattern.test(value);

export const validateNumber = function (phoneNumber) {
  // Validate Number length and normalize to +e164
  var phoneNumberPattern = /^\(?\+?1?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  if (phoneNumberPattern.test(phoneNumber)) {
    if (phoneNumber[0] == 1) {
      phoneNumber = "+" + phoneNumber.replace(/\D/g, "");
    } else if (phoneNumber[0] == "+") {
      phoneNumber = "+" + phoneNumber.replace(/\D/g, "");
    } else {
      phoneNumber = "+1" + phoneNumber.replace(/\D/g, "");
    }
    return phoneNumber;
  } else {
    return false;
  }
};
